import React from 'react';

export default function Footer (props) {
  return props.translate(
    <div className="bg-dark text-light py-4 text-center small">
      <div className="d-flex justify-content-center">
        <div>
          <a className="text-light" href="http://www.vitamin-i.jp/privacy.html">個人情報保護ポリシー</a>
        </div>
        <div className="ml-3">
          <a className="text-light" href="https://www.vitamin-i.jp/about">特定商取引法表示</a>
        </div>
      </div>
      <div className="mt-2">
        <address>Copyright (c) VSM all rights reserved.</address>
      </div>
    </div>
  );
};
